<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.84375 12.5002L12.1714 3.17258C12.629 2.71493 13.371 2.71493 13.8286 3.17258L23.1562 12.5002M5.1875 10.1564V20.7033C5.1875 21.3505 5.71217 21.8752 6.35938 21.8752H10.6562V16.7971C10.6562 16.1499 11.1809 15.6252 11.8281 15.6252H14.1719C14.8191 15.6252 15.3438 16.1499 15.3438 16.7971V21.8752H19.6406C20.2878 21.8752 20.8125 21.3505 20.8125 20.7033V10.1564M9.09375 21.8752H17.6875"
				:stroke="color"
				stroke-width="1.625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgHome',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
